export type RuntimeBudgetSample={fps:number;p95:number;drawCalls?:number;triangles?:number;actors?:number}
export type RuntimeBudgetDecision={lodBias:number;skipParticles:boolean;capFluidDroplets:number;reason:string}
export function decideRuntimeBudget(s:RuntimeBudgetSample):RuntimeBudgetDecision{
 if(s.fps<28||s.p95>55)return{lodBias:2,skipParticles:true,capFluidDroplets:8,reason:'critical-frame-budget'}
 if(s.fps<45||s.p95>34)return{lodBias:1,skipParticles:false,capFluidDroplets:18,reason:'reduced-frame-budget'}
 return{lodBias:0,skipParticles:false,capFluidDroplets:42,reason:'full-quality'}
}
export function assertPlayableBudget(s:RuntimeBudgetSample){const d=decideRuntimeBudget(s);if(s.fps<20)throw new Error('Unplayable FPS budget '+s.fps);return d}

export type RuntimeDprState={dpr:number;pressureSamples:number;stable:number;lastAdjustAt:number}
export function nextFightDpr(state:RuntimeDprState,s:RuntimeBudgetSample,now:number){
 const budget=decideRuntimeBudget(s)
 let dpr=state.dpr,pressureSamples=state.pressureSamples,stable=state.stable,lastAdjustAt=state.lastAdjustAt,adjusted=false
 if(budget.reason==='critical-frame-budget'){
  pressureSamples+=1;stable=0
  const emergency=s.fps<20||s.p95>70,interval=emergency?750:1500,drop=emergency?.22:.14
  if(now-lastAdjustAt>=interval){dpr=Math.max(.7,dpr-drop);pressureSamples=0;lastAdjustAt=now;adjusted=Math.abs(dpr-state.dpr)>=.045}
 }else if(budget.reason==='reduced-frame-budget'){
  pressureSamples+=1;stable=0
  if(pressureSamples>=2&&now-lastAdjustAt>=3000){dpr=Math.max(.75,dpr-.08);pressureSamples=0;lastAdjustAt=now;adjusted=Math.abs(dpr-state.dpr)>=.045}
 }else{
  pressureSamples=0;stable+=1
  if(stable>=5&&now-lastAdjustAt>=7000){dpr=Math.min(1.15,dpr+.04);stable=0;lastAdjustAt=now;adjusted=Math.abs(dpr-state.dpr)>=.035}
 }
 return{dpr,pressureSamples,stable,lastAdjustAt,adjusted,budget}
}
